export default {
    EARLESETTLEMENT: 'EARLYSETTLEMENT',
    FINANCIALSTATUS: 'FINANCIALSTATUS'
}